/* eslint-disable react/no-array-index-key */
import React from 'react';

export const getHighlightedText = (text: string, search: string) => {
  if (text && search.length > 2) {
    const parts = text.split(new RegExp(`(${search})`, 'gi'));

    return (
      <span>
        {parts.map((part, index) => (
          <span key={`${part}-${index}`} style={part.toLowerCase() === search.toLowerCase() ? { color: '#e30018' } : {}}>
            {part}
          </span>
        ))}
      </span>
    );
  }

  return text;
};
